import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { Animated, Pressable } from 'react-native';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { useAnimation } from '../Animations/AnimationHooks';
import { BoldView } from '../Typography/BoldView';
export const DatePickerButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.datePickerButton,
    style(theme) {
        var _a, _b;
        return {
            container: {
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap'
            },
            btn: {
                borderRadius: 8,
                paddingVertical: 7,
                paddingHorizontal: 10,
                backgroundColor: 'rgba(28, 69, 152, 0)'
            },
            selectedBtn: {
                backgroundColor: ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary_color) || 'rgba(28, 69, 152, 1)'
            },
            text: {
                textAlign: 'center',
                fontSize: 12,
                color: 'rgb(57, 78, 102)'
            },
            inactiveText: {
                color: 'rgb(99, 120, 143)',
                fontWeight: '400'
            },
            border: {
                borderStyle: 'dashed',
                borderWidth: 1,
                borderColor: ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || 'rgba(28, 69, 152, 1)'
            },
            disabled: {
                textDecorationLine: 'line-through'
            }
        };
    }
})(({ style, onChange, value, text, border, selected, inactive, disabled }) => {
    var _a, _b, _c, _d;
    const [animation, setAnimation] = useAnimation({ initialValue: 0, duration: 200, nativeDriver: false });
    useEffect(() => {
        setAnimation(selected ? 1 : 0);
    }, [selected]);
    const handleSelectDate = useCallback(() => !disabled && onChange(value.format('YYYY-MM-DD')), [value, disabled]);
    const backgroundColor = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [(_a = style === null || style === void 0 ? void 0 : style.btn) === null || _a === void 0 ? void 0 : _a.backgroundColor, (_b = style === null || style === void 0 ? void 0 : style.selectedBtn) === null || _b === void 0 ? void 0 : _b.backgroundColor]
    });
    const color = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [inactive ? (_c = style === null || style === void 0 ? void 0 : style.inactiveText) === null || _c === void 0 ? void 0 : _c.color : (_d = style === null || style === void 0 ? void 0 : style.text) === null || _d === void 0 ? void 0 : _d.color, 'rgb(255, 255, 255)']
    });
    return (_jsx(Pressable, { style: style === null || style === void 0 ? void 0 : style.container, onPress: handleSelectDate, children: _jsx(Animated.View, { style: [style === null || style === void 0 ? void 0 : style.btn, border && (style === null || style === void 0 ? void 0 : style.border), { backgroundColor }], children: _jsx(BoldView, { textStyle: [style === null || style === void 0 ? void 0 : style.text, inactive && (style === null || style === void 0 ? void 0 : style.inactiveText), { color }, disabled && (style === null || style === void 0 ? void 0 : style.disabled)], children: text }) }) }));
});
